import React,{useEffect, useState,useRef}  from 'react';
import PropTypes from 'prop-types';
import { Autocomplete } from '@react-google-maps/api';
import { isSet } from '../../../utils/commonUtils';


// import {setAndGetAttributes} from './FormInputFunctions';

const AddressInput = (props)=>{
  // Props Attr
   const {
    type,
    className,
    placeholder,
    value,
    style,
    name,
    required,
    readOnly,
    disabled,
    id
  } = props;
  // Handler
   const {
    changeHandler,
    isFirstLetterCaps
    // onKeyPressHandler
  } = props;

    const [isAutocompleteActive, setIsAutocompleteActive] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const blurTimerRef = useRef(null);

    const removePacContainers = () => {
      try {
        document.querySelectorAll('.pac-container').forEach((el) => el.remove());
      } catch (e) {
        // no-op
      }
    };

    useEffect(() => {
      return () => {
        if (blurTimerRef.current) {
          clearTimeout(blurTimerRef.current);
        }
        removePacContainers();
      };
    }, []);

    useEffect(()=>{
        setInputValue(value);
    },[value]);
    
    const handlePlaceSelect = () => {
        const ac = autocompleteRef.current;
        if (ac != null) {
            const place = ac.getPlace();
            // console.log('place',place);
            let searchTerm = {
                address:place.formatted_address,
            };
                try{
                    place.address_components.map((item)=>{
                        if(item.types.indexOf('route')!==-1){
                            searchTerm = {...searchTerm,'street':item.long_name};
                        }else if(item.types.indexOf('locality')!==-1 || item.types.indexOf('administrative_area_level_3')!==-1){
                            searchTerm = {...searchTerm,'city':item.long_name};
                        }else if(item.types.indexOf('administrative_area_level_1')!==-1 ){
                            searchTerm = {...searchTerm,'state':item.short_name}; 
                        }else if(item.types.indexOf("country")!==-1 ){
                            searchTerm= {...searchTerm,'country':item.long_name}; 
                        }
                        else if(item.types.indexOf("administrative_area_level_2")!==-1 ){
                          searchTerm= {...searchTerm,'county':item.long_name}; 
                      }
                        else if(item.types.indexOf("postal_code")!==-1 ){
                            searchTerm= {...searchTerm,'zipcode':item.long_name}; 
                        }
                    }); 
                }catch(e){

                }
                setInputValue(place.formatted_address);
                changeHandler(place.formatted_address,{addressParam:searchTerm});
                // After selection, tear down the dropdown so it can't linger/overlap.
                setIsAutocompleteActive(false);
                removePacContainers();
          }else{
             changeHandler('',{
                street:'',
                city:'',
                state:'',
                zipcode:'',
             });
             setIsAutocompleteActive(false);
             removePacContainers();
          }
    };
    const handleInputChange = (e) => {
      let targetValue = e.target.value;
      // Convert the first letter of each word to uppercase if required
      if (isFirstLetterCaps) {
        targetValue = targetValue
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }
      if (isSet(targetValue, null) === null) {
        changeHandler("", {
          street: "",
          city: "",
          state: "",
          zipcode: "",
        });
      }
      setInputValue(targetValue);
      changeHandler(targetValue, {});
    };

    const handleFocus = () => {
      if (blurTimerRef.current) {
        clearTimeout(blurTimerRef.current);
        blurTimerRef.current = null;
      }
      setIsAutocompleteActive(true);
    };

    const handleBlur = () => {
      // Delay so a click on a suggestion can register before unmount.
      blurTimerRef.current = setTimeout(() => {
        setIsAutocompleteActive(false);
        removePacContainers();
      }, 200);
    };

    const inputEl = (
      <input 
        ref={inputRef}
        type={type}
        disabled={disabled}
        className={className}
        id={id}
        name={name}
        placeholder={placeholder}
        {...style}
        readOnly={readOnly}
        value={inputValue}
        required={required}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleInputChange} 
      />
    );

    return(
        <>
        {isAutocompleteActive ? (
          <Autocomplete
            onLoad={(autocomplete) => {
              autocompleteRef.current = autocomplete;
            }}
            onUnmount={() => {
              autocompleteRef.current = null;
            }}
            onPlaceChanged={handlePlaceSelect}
            options={{
              componentRestrictions: { country: 'us' } // Restrict to US addresses
            }}
          >
            {inputEl}
          </Autocomplete>
        ) : (
          inputEl
        )}
        </>
          
    )
}
AddressInput.defaultProps = {
  type:'text',
  disabled:false,
  isMandatory:false,
  className: 'form-control form-control-solid',
  placeholder:'',
  value:'',
  id:'',
  style:{},
  onKeyPressHandler:()=>{},
  readOnly:false,
  required:false,
  validation:{
    isValid:true,message:''
  },
  scrollingArea:'modal-body'

}
AddressInput.propTypes = {
  type: PropTypes.string,
  isMandatory: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  // validationRules: PropTypes.array,
  // valid: PropTypes.bool,
  changeHandler: PropTypes.func.isRequired,
};

export default AddressInput;
